export const routes = [
  ...require('./generator/routes').routes
]
